import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as o } from "../../chunks/tslib.es6.js";
import { JSONSupport as r } from "../../core/JSONSupport.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { reader as t } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as e } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as p } from "../../core/accessorSupport/decorators/writer.js";
import { fromJSON as i } from "./domains.js";
import a from "./FeatureTemplate.js";

var c = /*#__PURE__*/function (_r) {
  _inherits(c, _r);

  var _super = _createSuper(c);

  function c(o) {
    var _this;

    _classCallCheck(this, c);

    _this = _super.call(this, o), _this.id = null, _this.name = null, _this.domains = null, _this.templates = null;
    return _this;
  }

  _createClass(c, [{
    key: "readDomains",
    value: function readDomains(o) {
      var r = {};

      for (var _i = 0, _Object$keys = Object.keys(o); _i < _Object$keys.length; _i++) {
        var _s = _Object$keys[_i];
        r[_s] = i(o[_s]);
      }

      return r;
    }
  }, {
    key: "writeDomains",
    value: function writeDomains(o, r) {
      var s = {};

      for (var _i2 = 0, _Object$keys2 = Object.keys(o); _i2 < _Object$keys2.length; _i2++) {
        var _e = _Object$keys2[_i2];
        var t;
        if (o[_e]) s[_e] = null == (t = o[_e]) ? void 0 : t.toJSON();
      }

      r.domains = s;
    }
  }]);

  return c;
}(r);

o([s({
  json: {
    write: !0
  }
})], c.prototype, "id", void 0), o([s({
  json: {
    write: !0
  }
})], c.prototype, "name", void 0), o([s({
  json: {
    write: !0
  }
})], c.prototype, "domains", void 0), o([t("domains")], c.prototype, "readDomains", null), o([p("domains")], c.prototype, "writeDomains", null), o([s({
  type: [a],
  json: {
    write: !0
  }
})], c.prototype, "templates", void 0), c = o([e("esri.layers.support.FeatureType")], c);
var m = c;
export { m as default };